import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useStudio } from '../hooks/useStudio';

/**
 * Protects studio editor pages so only the studio owner can access them.
 * Frontend checks improve UX, but backend authorization must still enforce this.
 */
const StudioOwnerRoute = ({ children }) => {
  const { id: studioId } = useParams();
  const { user: currentUser } = useSelector((state) => state.auth || {});
  const currentUserId = currentUser?._id || currentUser?.id;

  const { studio, loading } = useStudio(studioId);

  if (loading || !studioId) {
    return null;
  }

  if (!studio) {
    return <Navigate to="/services-studios" replace />;
  }

  const studioOwnerId = studio?.User?.id || studio?.User?._id || studio?.userID;
  const isOwner = Boolean(currentUserId && studioOwnerId && currentUserId === studioOwnerId);

  if (!isOwner) {
    return <Navigate to="/error/403" replace />;
  }

  return children;
};

export default StudioOwnerRoute;
